import React from 'react';
import { Database, Plus } from 'lucide-react';
import { Glyph, MetaStat, Panel, PrimaryAction, Row, RowText, ScreenHeader } from './ui';

// ── Tables ───────────────────────────────────────────────────────────────────
// Structured data Giga can read and write. Like tracks, every table belongs to a
// group, so access follows the group.
//
// Rebuilt on the shared primitives in ./ui.tsx — the teal-tinted icon square and
// the grid of grey bordered cards are gone. Row size, source and last update now
// sit in aligned columns, because those are the three things you scan a table
// directory to compare. No copy or data changed.
// ─────────────────────────────────────────────────────────────────────────────

const TABLES: {
  name: string;
  group: string;
  rows: number;
  columns: number;
  source: string;
  updated: string;
}[] = [{
  name: 'Creator Outreach',
  group: 'Giga Marketing',
  rows: 248,
  columns: 11,
  source: 'Notion',
  updated: '4m ago'
}, {
  name: 'Integration Coverage',
  group: 'Giga Master',
  rows: 96,
  columns: 8,
  source: 'Giga native',
  updated: '1h ago'
}, {
  name: 'Content Calendar',
  group: 'Giga Marketing',
  rows: 132,
  columns: 9,
  source: 'Airtable',
  updated: '2h ago'
}, {
  name: 'Waitlist Signups',
  group: 'Giga Master',
  rows: 4216,
  columns: 6,
  source: 'Google Sheets',
  updated: '12m ago'
}, {
  name: 'Ad Spend by Channel',
  group: 'Giga Marketing',
  rows: 74,
  columns: 12,
  source: 'Google Sheets',
  updated: 'Yesterday'
}, {
  name: 'Skills Backlog',
  group: 'Giga Master',
  rows: 61,
  columns: 7,
  source: 'Giga native',
  updated: '3d ago'
}];
export function TablesView() {
  return <div data-id="element-2872" data-mp="241aumusqgtuu">
      <ScreenHeader title="Tables" description="Structured data Giga can read and write — created here or synced from a connected tool. Tables belong to a group, so access follows the group." action={<PrimaryAction label="New table" data-id="element-2874" data-mp="29xzuykhc2ci">
            <Plus size={15} data-id="element-2875" data-mp="2b94t1pnvg57" />
            New table
          </PrimaryAction>} data-id="element-2873" data-mp="241kmyp193d3p" />

      <Panel className="mt-6" data-id="element-2876" data-mp="1wpwfpmn559z0">
        {TABLES.map(table => <Row key={table.name} className="flex-wrap gap-y-4 md:flex-nowrap" data-id="element-2877" data-mp="1wo39g8gfwrrj">
            <Glyph icon={Database} data-id="element-2878" data-mp="21ifswihx233a" />
            <RowText title={table.name} meta={table.group} data-id="element-2879" data-mp="1ms09n992957r" />

            <dl className="flex w-full shrink-0 items-start gap-6 md:w-auto md:gap-10" data-id="element-2880" data-mp="1mtjlmnnoou3q">
              <span className="w-16" data-id="element-2881" data-mp="1rruvgydzb4ly">
                <MetaStat label="Rows" value={table.rows.toLocaleString('en-US')} data-id="element-2882" data-mp="1roqppwkv80t6" />
              </span>
              <span className="w-16" data-id="element-2883" data-mp="2kfqre0vq4sho">
                <MetaStat label="Columns" value={table.columns} data-id="element-2884" data-mp="2kepfju6vw1yw" />
              </span>
              <span className="w-28" data-id="element-2885" data-mp="25j9hzf73hnxr">
                <MetaStat label="Source" value={<span className="text-[13.5px] font-semibold" data-id="element-2887" data-mp="2ahksls57s2h1">{table.source}</span>} data-id="element-2886" data-mp="25i8658i98xez" />
              </span>
              <span className="w-24" data-id="element-2888" data-mp="u3kummpximwf">
                <MetaStat label="Updated" value={<span className="text-[13.5px] font-semibold" data-id="element-2890" data-mp="u5fgq4cxsl23">{table.updated}</span>} data-id="element-2889" data-mp="u2jisg139wdn" />
              </span>
            </dl>
          </Row>)}
      </Panel>
    </div>;
}